module.exports = __webpack_public_path__ + "img/pen.a5da6b63.svg";